import { TooltipDirectiveModule } from '@toro/common/shared/directives';
import { CheckoutAboutFeesComponent } from './components/checkout-about-fees/checkout-about-fees.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CheckoutWrapperComponent } from './wrapper/checkout-wrapper.component';
import { CheckoutAutomaticComponent } from './components/checkout-automatic/checkout-automatic.component';
import { DialogPriceEditionComponent } from './components/dialog-price-edittion/dialog-price-edition.component';
import { ChipsComponent } from './components/dialog-price-edittion/chips/chips.component';

import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CheckoutHeaderComponent } from './components/checkout-header/checkout-header.component';
import { CheckoutManualComponent } from './components/checkout-manual/checkout-manual.component';
import { CommonModule } from '@angular/common';
import { CheckoutInvestmentComponent } from './components/checkout-investment/checkout-investment.component';
import { ContractsComponent } from './components/checkout-investment/contracts/contracts.component';
import { CheckoutResumeComponent } from './components/checkout-resume/checkout-resume.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { TrPlannedCheckoutInputModule } from '@toro/common/shared/components/tr-planned-checkout-input/tr-planned-checkout-input.module';
import { StockPipesModule } from '../../../pipes/stock-pipes.module';
import { TrCheckboxModule } from '@toro/common/shared/components/tr-forms-inputs/tr-checkbox/tr-checkbox.module';
import { TrStepInputModule } from '@toro/common/shared/components/tr-step-input/tr-step-input.module';

import { SuccessAsidePanelModule } from "../success-aside-panel/success-aside-panel.module";
import { CheckoutSuitabilityDisclaimerModule } from '../../components/checkout-suitability-disclaimer/checkout-suitability-disclaimer.module';
import { WithoutSuitabilityDisclaimerModule } from '../../components/without-suitability-disclaimer/without-suitability-disclaimer.module';

@NgModule({
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    imports: [
        SvgIconModule,
        MatSlideToggleModule,
        CommonModule,
        TrPlannedCheckoutInputModule,
        StockPipesModule,
        FormsModule,
        ReactiveFormsModule,
        TrCheckboxModule,
        TrStepInputModule,
        SuccessAsidePanelModule,
        CheckoutSuitabilityDisclaimerModule,
        WithoutSuitabilityDisclaimerModule,
        TooltipDirectiveModule,
    ],
    declarations: [
        CheckoutWrapperComponent,
        CheckoutHeaderComponent,
        CheckoutInvestmentComponent,
        CheckoutManualComponent,
        CheckoutAutomaticComponent,
        CheckoutAboutFeesComponent,
        DialogPriceEditionComponent,
        ContractsComponent,
        CheckoutResumeComponent,
        ChipsComponent,
        SkeletonComponent
    ],
    exports: [],
    entryComponents: [
        CheckoutWrapperComponent,
        DialogPriceEditionComponent,
        CheckoutResumeComponent,
        CheckoutAboutFeesComponent
    ],
    providers: [
    ],
})
export class CheckoutPanelModule {}
